import { useTranslation } from 'react-i18next';
import { LANGUAGES } from '../../i18n';
import { Icon, Languages } from '../ui/Icon';
import Spinner from '../ui/Spinner';

/** Autonym ("Català", "Español") — reads right whatever the UI language is. */
function languageLabel(code: string): string {
  return LANGUAGES.find(l => l.code === code)?.name ?? code.toUpperCase();
}

/**
 * Shown in the import review when the document speaks a language the trip
 * doesn't. Translating is the user's call: an imported itinerary is their own
 * writing, so we offer it rather than silently rewriting it.
 */
export default function ImportLanguageNotice({ document, trip, translating, onTranslate }: {
  document: string;
  trip: string;
  translating: boolean;
  onTranslate: () => void;
}) {
  const { t } = useTranslation();

  return (
    <div className="flex items-start gap-2.5 p-3 rounded-xl bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-900/50">
      <Icon as={Languages} size={15} className="text-amber-600 dark:text-amber-400 shrink-0 mt-0.5" />
      <div className="flex-1 min-w-0">
        <p className="text-[13px] font-semibold text-amber-900 dark:text-amber-200">
          {t('import.language.title', { document: languageLabel(document) })}
        </p>
        <p className="text-[11.5px] text-amber-800/80 dark:text-amber-300/80 mt-0.5 leading-snug">
          {t('import.language.hint', { trip: languageLabel(trip) })}
        </p>
      </div>
      <button
        type="button"
        onClick={onTranslate}
        disabled={translating}
        className="btn-secondary shrink-0 text-[12px] px-2.5 py-1.5"
      >
        {translating
          ? <Spinner size="sm" />
          : t('import.language.action', { trip: languageLabel(trip) })}
      </button>
    </div>
  );
}
